import styled, { css } from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { ChipSizeEnum, ShapeEnum } from "./Chip";

type StyledChipProps = {
  $borderColor: string;
  $backgroundColor: string;
  $shape: ShapeEnum;
  $size?: ChipSizeEnum;
  $selected?: boolean;
  $isString?: boolean;
  $fullWidth?: boolean;
  $readonly?: boolean;
  $hoverEffect?: boolean;
  $borderWidth?: number;
  $textColor?: string;
  $hoverBackgroundColor?: string;
};

function customChipHeight($size: ChipSizeEnum) {
  if ($size === ChipSizeEnum.BIG) {
    return "30px";
  }
  if ($size === ChipSizeEnum.REGULAR) {
    return "24px";
  }
  if ($size === ChipSizeEnum.SMALL) {
    return "18px";
  }
  if ($size === ChipSizeEnum.X_SMALL) {
    return "14px";
  }
}

export const StyledChip = styled.div<StyledChipProps>`
  background-color: ${({ $selected, $borderColor, $backgroundColor }) =>
    $selected ? $borderColor : $backgroundColor};
  border: ${({ $borderColor, $borderWidth }) =>
    `${$borderWidth}px solid ${$borderColor}`};
  height: ${({ $size }) => ($size ? customChipHeight($size) : "auto")};
  width: ${({ $fullWidth }) => ($fullWidth ? "auto" : "")};
  border-radius: ${({ $shape: $radiusSize }) =>
    $radiusSize === ShapeEnum.ROUND
      ? theme.variables.border_radius_5
      : theme.variables.border_radius_4};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $readonly }) => ($readonly ? "default" : "pointer")};
  white-space: nowrap;
  padding: ${({ $isString }) => ($isString ? "0px 15px" : 0)};
  min-width: 0;

  ${({ $hoverEffect, $hoverBackgroundColor }) =>
    $hoverEffect &&
    css`
      & .details-icon-wrapper {
        opacity: 0;
        transition: opacity 0.15s ease-in-out;
      }

      &:hover {
        background-color: ${$hoverBackgroundColor ?? theme.colors.purple_hover};

        & .details-icon-wrapper {
          opacity: 1;
        }
        & > span > span,
        & > div > span > span {
          color: ${theme.colors.white};
        }
      }
    `}
  & > span > span {
    color: ${({ $selected, $borderColor, $textColor }) =>
      $selected ? theme.colors.white : ($textColor ?? $borderColor)};
  }

  & > div > span > span {
    color: ${({ $selected, $borderColor, $textColor }) =>
      $selected ? theme.colors.white : ($textColor ?? $borderColor)};
  }
`;
